export enum PhotoMediaTypeEnum {
  IMAGE = 1,
  VIDEO = 2,
}

export interface PhotoInterface {
  catalog: boolean
  id: number
  position: number
  product: boolean
  url: string
  mediaType: PhotoMediaTypeEnum
}

export interface PhotosInterface {
  catalog: PhotoInterface[]
  product: PhotoInterface[]
  landing: PhotoInterface[]
  thumb: PhotoInterface[]
  custom: PhotoInterface[]
}

export interface PhotoSetInterface {
  catalog: PhotoInterface
  product: PhotoInterface
  landing: PhotoInterface
  thumb: PhotoInterface
  custom: PhotoInterface
}

export default PhotoInterface
